export const determineFormAlertClass = (code) => {
  switch (code) {
    case 0:
      return 'd-block alert-danger';
    case 1:
      return 'd-block alert-success';
    default:
      return '';
  }
};
export const formIsEmpty = (form) => {
  if (!Object.keys(form).length) return true;

  for (const key in form) {
    if (!form[key]) return { isEmpty: true, key };
  }

  return false;
};

export const campaignCanBeEdited = (campaign) => {
  if (
    campaign.status === 'draft' ||
    campaign.status === 'cancelled' ||
    (campaign.status === 'queued' && campaignCanBeCancelled(campaign.schedule?.date))
  )
    return true;
  return false;
};

export const campaignCanBeCancelled = (timestamp) => {
  const current_time = new Date();
  const campaign_date = new Date(timestamp);

  return Date.parse(campaign_date) - Date.parse(current_time) > 5 * 60 * 1000;
};

export const validatePassword = (userPassword) => {
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+[{\]};:'",<.>/?]).*$/;
  return passwordRegex.test(userPassword);
};
